export const getChildById = (items, id, key='id') => {
  const item = items.filter(child=>{
    const type = typeof child[key];
    if(type === 'string'){
      return child[key] === id;
    }else{
      return child[key] === parseInt(id,10);
    }
  }) || [];

  if(item.length === 1){
    return item[0];
  }else if(item.length === 0){
    return undefined;
  }else{
    return undefined;
  }
};

export const getChildKeyById = (items, id, key='id') => {
  let keyNum = null;
  items.forEach((item,k)=>{
    if(item[key] === parseInt(id,10)){
      keyNum = k;
    }
  });
  return keyNum;
};



// WEBPACK FOOTER //
// ./source/javascripts/utils/getChild.js